import { Injectable } from '@angular/core';
import Parse from 'parse';

@Injectable({
  providedIn: 'root'
})
export class ThumbnailService {

  constructor() { }

  /**
   * Get thumbnail for a transient from Parse
   *
   * @param transientId The ID of the transient
   * @returns Promise with the thumbnail URL or null if not available
   */
  async getThumbnail(transientId: string): Promise<string | null> {
    try {
      const query = new Parse.Query('transients');
      query.equalTo('xtrsrc_id', Number(transientId));

      const transient = await query.first();

      if (transient) {
        const thumbnailRef = transient.get('thumbnail_red');
        // Return the thumbnail URL if it exists and is not empty
        return thumbnailRef && thumbnailRef.trim() !== '' ? thumbnailRef : null;
      } else {
        console.warn(`Thumbnail service: Transient with ID ${transientId} does not exist.`);
        return null;
      }
    } catch (error) {
      console.error(`Thumbnail service: Error fetching thumbnail for transient ${transientId}:`, error);
      return null;
    }
  }
}
